import React, {Component} from 'react'
import Button from '../../components/UI/Button/Button'
import Loader from '../../components/UI/Loader/Loader'
import Input from '../../components/UI/Input/Input'
import Notification from '../../containers/UI/Notification/Notification'
import axios from 'axios'
import './Contact.css'
import Aux from '../../HOC/Auxi'




const FORM_INPUTS = {
    name: {
        label:"Name",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Enter your name please"
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=3 && this.value.length <=30){
                valid = true;
            }
            return valid
        },
        isValid: false, 
        errorMessage: "Name must be up to 3 letters",
        touched: false,
        iconName:"person"
    },
    email: {
        label:"Email",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Email", 
        },
        value:"",
        validation: function(){
            let valid = false;
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(emailRegex.test(this.value)){
                valid = true
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please input a valid email address",
        touched: false,
    },
    message: {
        label:"Message",
        elemType: "textarea",
        config: {
            placeholder: "Enter your message",
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=10){
                valid = true;
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please drop a nice message",
        touched: false,
    }
}

class Contact extends Component{
    state= {
        isFormValid: false,
        loading: false,
        isSubmited: false,
        errors: [],
        invalidFormErrorMessage:"Please, fill the forms accurately before you submit",
        formInputs:{
            name: {...FORM_INPUTS.name},
            email:{...FORM_INPUTS.email}, 
            message: {...FORM_INPUTS.message}
        },
        notification: {
            show:false,
            data: {
                status: 'primary',
                content: null
            }
        },
    }
    componentDidMount(){
        window.scrollTo(0,0)
    }
    refreshNotification = () => {
        this.setState(state => {
            return{
                ...state, 
                notification: {
                    ...state.notification, 
                    show:false
                }
            }
        })
    }
    formElementChangeHandler = async (event, elemName)=> {
        let formInputs = {...this.state.formInputs}
        let element = formInputs[elemName]
        element.value= event.target.value;
        element.isValid = element.validation()
        element.touched = true;
        await this.setState({formInputs: formInputs})
        await this.checkValidity()
    }
    checkValidity = async()=>{
        let  theFormIsValid = true;
        for(let elemName in this.state.formInputs){
            if(this.state.formInputs[elemName].isValid === false){
                theFormIsValid = false;
                break;
            }
        }
        await this.setState({isFormValid: theFormIsValid})
    }
    onSubmitHandler = async (event)=>{
        let data  = {}
        event.preventDefault();
        await this.setState({isSubmited: true});
        if(this.state.isSubmited && this.state.isFormValid){
            for(let key in this.state.formInputs){
                const deKey= key;
                data[deKey]= this.state.formInputs[deKey].value
            }
            await this.setState({loading: true})
            axios.post('https://blossomandflourish-backend.herokuapp.com/api/contact/add', data)
            .then(res => {
                const notification = {
                    show: true, 
                    data: {
                        status: 'success', 
                        content: res.data.message
                    }
                }
                this.setState({loading: false,formInputs: {...FORM_INPUTS }, notification})
                console.log(this.state.notification)
                
            })
            .catch(err=> {
                this.setState({loading: false})
                this.setState({errors: err})
                console.log(err)
            })
            
        }
    }
    render(){
        let formElements = [];
        for(let elementName in this.state.formInputs){
            formElements.push({
                id: elementName, 
                config: this.state.formInputs[elementName]
            })
        }
        let subMitErrorClass = ["ErrorMessage"]
        if(this.state.isSubmited && !this.state.isFormValid){
            subMitErrorClass.push("Show__Error")
        }else{
            subMitErrorClass.push("Hide__Error")
        }
        let toDisplay =  (
            <Button name="SEND MESSAGE"/>
        )
        if(this.state.loading){
            toDisplay = <Loader />
        }
        let displayError = null
        if(this.state.errors.length > 0){
            displayError = this.state.errors.map(err => {
                return (
                    <p className="ErrorMessage"> {err} </p>
                )
            })
        }
        return(
            <Aux>
                <Notification 
                show={this.state.notification.show} 
                data={this.state.notification.data}
                refresh={this.refreshNotification}
                />
                <div className="Contact contain">
                    <div className="FormDiv">
                        <p className="Contact_Title">CONTACT US</p>
                        <form onSubmit={this.onSubmitHandler}>
                            {formElements.map(elem => {
                                return(
                                    <Input
                                        key={elem.id}
                                        elemType={elem.config.elemType}
                                        config={elem.config.config}
                                        value={elem.config.value}
                                        iconName={elem.config.iconName}
                                        errorMessage={elem.config.errorMessage}
                                        changed={(event)=>this.formElementChangeHandler(event, elem.id)}
                                        valid={elem.config.isValid}
                                        touched={elem.config.touched}
                                        label={elem.config.label}
                                    />
                                )
                            })}
                            <div className="LoaderButton">
                                {toDisplay}
                            </div>
                        </form>
                    </div>
                    <div className="Contact_Map ">
                        <div className="Map_Fram">
                            <iframe  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.8608146024426!2d7.486601214346002!3d6.411923126230286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1044a10c04c65e59%3A0xa3bbed6e0461385f!2sIdaw-river%20girls%20secondary%20school%20(IRGSS)!5e0!3m2!1sen!2sng!4v1597447788700!5m2!1sen!2sng"  width="600" height="450" frameBorder="0" style={{border:0}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
                        </div>
                    </div>
                </div>
            </Aux>
        )
    }
}



export default Contact